import styled from '@emotion/styled';
import { css } from '@emotion/react';
import COLORS3 from '../../styles/emotion/colors3';
import SPACING from '../../styles/emotion/spacing';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';

export const TilesWrapper = styled.div`
  position: relative;
  display: flex;
  transition: all 0.2s ease-in-out;
  scroll-behavior: smooth;
  white-space: nowrap;
  flex-wrap: initial;
  overflow-x: auto;
  min-width: 100%;
  padding: ${SPACING.LG} 0;
  column-gap: ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S24} 0;
    column-gap: ${SPACING.S16};
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    column-gap: ${SPACING.S32};
  }

  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    column-gap: ${SPACING.LG};
  }

  &::-webkit-scrollbar {
    height: 8px;
    background: ${COLORS3.BLACK_005};
    border-radius: 20px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background: ${COLORS3.BLACK_015};
  }
`;

const ScrollButton = styled.div`
  align-self: center;
  position: absolute;
  z-index: 2;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS3.BLACK_100};
  color: ${COLORS3.WHITE_100};
  border-radius: 50%;
`;
export const LeftButton = styled(ScrollButton)`
  left: -8px;
`;

export const RightButton = styled(ScrollButton)`
  right: -8px;
`;

export const ScrollContainer = styled.div<{ scrollable: boolean }>`
  display: flex;
  position: relative;

  &:hover {
    ${LeftButton}, ${RightButton} {
      visibility: ${(props) => (props.scrollable ? 'visible' : 'hidden')};
    }
  }
`;

export const hidden = css`
  display: none;
`;
